import axios from 'axios';
import {refreshToken} from "@/app/services/refreshToken";
import {getCookie} from "cookies-next";

const axiosInterceptorInstance = axios.create({
    baseURL: `${process.env.NEXT_PUBLIC_API_URL}`, // Replace with your API base URL
});
axiosInterceptorInstance.interceptors.request.use((req) => {
    // Modify the request config here (add headers, authentication tokens)
    return req;
}, (error) => {
    // Handle request errors here
    // return Promise.reject(error);
});
// Response interceptor
axiosInterceptorInstance.interceptors.response.use((response) => {
    // Modify the response data here
    return response;
}, (error) => {
    // Handle response errors here
    if (error.response.status === 401) {
        if (window.location.href !== `${process.env.NEXT_PUBLIC_FE_LOCATION}/login` && window.location.href !== `${process.env.NEXT_PUBLIC_FE_LOCATION}/register` && window.location.href !== `${process.env.NEXT_PUBLIC_FE_LOCATION}/`) {
            if (getCookie('refresh')) {
                refreshToken();
            } else {
                // za unathenticated trenutno je code 401 da se promjeni na 403
                // window.location.href = '/login'
            }
        }
        //     request refresh token
    }

    return Promise.reject(error);
});
// End of Response interceptor

export default axiosInterceptorInstance;